import api from "../lib/api";

export default class TokenServices {
	static async hasTokenCookies() {
		try {
			const response = await api.post("/auth/whoIAm", {
				withCredentials: true,
			});
			return response.status === 200;
		} catch (error) {
			// eslint-disable-next-line
			//@ts-ignore
			const { response } = error;
			if (!response) return false;
			const expiredTokenRegex =
				/The token has expired at \d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}Z/;
			// eslint-disable-next-line
			//@ts-ignore
			if (expiredTokenRegex.test(error.response.data.message)) {
				return true; // O token expirou
			}
			return false; // Outro tipo de erro
		}
	}

	static async login() {
		const username = process.env.REACT_APP_API_USERNAME;
		const password = process.env.REACT_APP_API_PASSWORD;
		const response = await api.post(
			"/auth/login",
			{
				username: username,
				password: password,
			},
			{
				withCredentials: true,
			}
		);
		if (response.status === 200) return true;
		return false;
	}

	static async refreshToken() {
		try {
			const response = await api.post("/user/refresh");
			if (response.status === 200) return true;
		} catch (error) {
			// eslint-disable-next-line
			// @ts-ignore
			document.cookie =
				"accessToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
			window.location.reload();
		}
		return false;
	}
}
